module.exports = __webpack_public_path__ + "img/mastercard.168ebe1c.svg";